import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class PaymentService {
  constructor() {
    this.endpoints = createPrefix('/payment', {
      balance: '/balance',
      redirect: '/redirect',
      balanceHistory: '/balance/history',
    })
  }

  static create() {
    return new PaymentService()
  }

  async requestAddBalance(token) {
    const servicePath = this.endpoints.redirect()
    const { request } = await axios.get(servicePath)
    window.location.replace(
      `${request.responseURL}#token=${encodeURIComponent(token)}`
    )
  }

  async requestBalance() {
    const servicePath = this.endpoints.balance()
    const { data } = await axios.get(servicePath)

    return data
  }

  async queryBalanceHistory(params) {
    const servicePath = this.endpoints.balanceHistory()
    const { data } = await axios.get(servicePath, { params })

    return data
  }
}
